var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgFb = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.497 19v-8.11h2.951l.454-3.566h-3.405v-1.27c0-1.03.277-1.732 1.7-1.732H15v-3.18A22.887 22.887 0 0012.357 1C9.742 1 7.952 2.65 7.952 5.7v1.624H5v3.567h2.951V19h3.546z"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgFb, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/fb.f13289e8.svg";
export { ForwardRef as ReactComponent };